import { ScriptModule } from 'ui/components';

export const ScriptModuleFeature: React.FC<Content.ScriptModule> = ({ content }) => {
	return (
	<ScriptModule {...content?.properties}  />
)};
